import { HEADER_POSITION_TYPE } from '@/scripts/constants/header'
import { actions } from './actions'
import { mutations } from './mutations'

export const header = {
  namespaced: true,
  state: {
    isCollapsed: false,
    isInBackground: false,
    currentMenuId: undefined,
    position: {
      type: 'fixed',
      height: null,
    },
    keyboardNavigation: {
      currentId: null,
      focusedElementIsInsideMainMenu: false,
      focusedElementIsInsideSubmenu: false,
      focusedElementIsLastInsideSubmenu: false,
      menuIds: [],
    },
    accountBulletIsVisible: false,
  },
  getters: {
    isInBackground: (state) => state.isInBackground,
    currentMenuId: (state) => state.currentMenuId,
    keyboardNavigation: (state) => state.keyboardNavigation,
    accountBulletIsVisible: (state) => state.accountBulletIsVisible,
    headerIsCollapsed: (state) => state.isCollapsed,
    isStaticHeader: (state) => state.position.type === HEADER_POSITION_TYPE.STATIC,
  },
  mutations,
  actions,
}
